export default "__VITE_ASSET__KdBJwM9o__"